import React from 'react';
import PropTypes from 'prop-types';
import './index.css';
import SafeIframe from '../../SafeIframe/SafeIframe';

const ASSET_TYPES = {
  image: 'image',
  video: 'video',
  sign: 'sign',
};

function PreviewModal({ data }) {
  const getPreviewImage = () => {
    return (
      <img
        data-test="preview-image"
        src={`/cms/data/v1/assets/${data?.fileId || data.id}/data`}
        alt={data.name}
        onError={e => {
          e.currentTarget.src = '/assets/images/icons/thumbnail.jpeg';
        }}
      />
    );
  };

  const getVideoPreview = () => {
    return (
      <video
        data-test="preview-video"
        src={`/cms/data/v1/assets/${data?.fileId || data.id}/data`}
        controls
      />
    );
  };

  const getSignPreview = () => {
    return (
      <SafeIframe
        dataTest="preview-sign"
        src={`/player/?sign=${data.id}&nocontrol=1`}
        title={data.name}
      />
    );
  };

  const getPreview = () => {
    switch (data.type) {
      case ASSET_TYPES.image:
        return getPreviewImage();
      case ASSET_TYPES.video:
        return getVideoPreview();
      case ASSET_TYPES.sign:
        return getSignPreview();
      default:
        return (
          <p data-test="preview-not-available">
            Preview not available for this asset type({data.type}).
          </p>
        );
    }
  };

  return (
    <div className="preview-modal-container">
      <div
        className="preview-modal"
        data-test="preview-modal"
        style={{ aspectRatio: `${data.width} / ${data.height}` }}
      >
        {getPreview()}
      </div>
    </div>
  );
}

PreviewModal.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    fileId: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
};

export default PreviewModal;
